import { render } from "./photos.vue?vue&type=template&id=4f70a83f&scoped=true"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"

import "./photos.vue?vue&type=style&index=0&id=4f70a83f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f70a83f"]])

export default __exports__